import api from './api'

const resource = '/employees'

export default {
    get(page, per_page, region, branch, outlet, q, position, default_password, last_login) {
        if(default_password == 99){
            default_password = '';
        }
        return api.get(`${resource}?page=${page}&region_code=${region}&branch_code=${branch}&outlet_code=${outlet}&q=${q}&position=${position}&default_password=${default_password}&per_page=${per_page}&last_login=${last_login}`);
    },
    getPost(slug){
        return api.get(`${resource}?slug=${slug}`);
    },
    add(params){
        return api.post(`${resource}`, params);
    },
    update(npp, params){
        return api.put(`${resource}/${npp}`, params);
    },
    deleteUser(npp){
        return api.delete(`${resource}/delete/${npp}`);
    },
    resetpassword(npp, params){
        return api.put(`${resource}/resetpassword/${npp}`, params);
    },
    getLog(npp){
        return api.get(`/logs/${npp}?per_page=100`);
    },
    import(){
        return api.post(`${resource}/import`);
    },
    export(region, branch, outlet){
        return api.get(`${resource}/data/export?region_code=${region}&branch_code=${branch}&outlet_code=${outlet}`, {responseType: 'blob'});
    },
    summary(){
        return api.get(`${resource}/data/summary`);
    },
    getApprove(page, q, region='', per_page) {
        if(region == 'null'){
            return api.get(`${resource}/approve/all?page=${page}&q=${q}&per_page=${per_page}`);
        }
        return api.get(`${resource}/approve/all?page=${page}&q=${q}&region=${region}`);
    },
    doApprove(code) {
        return api.post(`${resource}/approveoutlet/${code}`);
    },
    doReject(code) {
        return api.post(`${resource}/rejectoutlet/${code}`);
    },
}